import { getPromotions } from 'services/Client';

import { BannerType } from 'constants/enums';
import { ShopSettings } from 'types/shopSettings.interface';
import { isBannerEnabled } from 'utils/promotion';

export const getPromotionPromises = (
  shopSettings: ShopSettings,
  kioskMode: boolean,
  isDashboard: boolean,
  storeId: string,
) => {
  const promises = [];
  const defaultResponse = { data: [] };
  const isForDashboard = isDashboard && !kioskMode;

  promises.push(
    isBannerEnabled(shopSettings, BannerType.Hero) && isForDashboard
      ? getPromotions(BannerType.Hero, { locationPin: storeId })
      : defaultResponse,
  );
  promises.push(
    isBannerEnabled(shopSettings, BannerType.Specials) && isForDashboard
      ? getPromotions(BannerType.Specials, { locationPin: storeId })
      : defaultResponse,
  );
  promises.push(
    isBannerEnabled(shopSettings, BannerType.Highlights) && kioskMode
      ? getPromotions(BannerType.Highlights, { locationPin: storeId })
      : defaultResponse,
  );
  promises.push(
    isBannerEnabled(shopSettings, BannerType.Recommendations) && kioskMode
      ? getPromotions(BannerType.Recommendations, { locationPin: storeId })
      : defaultResponse,
  );

  return promises;
};
